import { useSuspenseQuery } from '@apollo/client';

import type { JobPostingSkillFragment } from '@xing-com/crate-jobs-graphql';
import { GetJobMatchingSkillsDocument } from '@xing-com/crate-jobs-graphql';

export type UseJobMatchingSkillsResponse = {
  matchedSkills?: JobPostingSkillFragment[];
  notMatchedSkills?: JobPostingSkillFragment[];
};

type Props = {
  slug: string;
};

export const useJobMatchingSkills = ({
  slug,
}: Props): UseJobMatchingSkillsResponse => {
  const { data } = useSuspenseQuery(GetJobMatchingSkillsDocument, {
    variables: { slug },
  });

  const skills = (data?.job?.__typename === 'VisibleJob' &&
    data.job.userProfileMatches?.skills) || {
    matchedSkills: [],
    notMatchedSkills: [],
  };

  return {
    matchedSkills: skills.matchedSkills?.filter((skill) => !!skill),
    notMatchedSkills: skills.notMatchedSkills?.filter((skill) => !!skill),
  };
};
